import { jsx as _jsx } from "react/jsx-runtime";
import { ToastType } from '@sphereon/ui-components.core';
import SSIToast from '../../components/messageBoxes/toasts/SSIToast';
export const toastConfig = {
    ssiToastSuccess: (params) => {
        const { title, message, onClick, props } = params;
        return _jsx(SSIToast, { type: ToastType.SUCCESS, title: title, message: message, showBadge: props?.showBadge, onClick: onClick });
    },
    ssiToastError: (params) => {
        const { title, message, onClick, props } = params;
        return _jsx(SSIToast, { type: ToastType.ERROR, title: title, message: message, showBadge: props?.showBadge, onClick: onClick });
    },
};
